import React from 'react';
import { Link } from 'react-router';
import { translate } from 'react-i18next';
import classnames from 'classnames';
import enhanceWithClickOutside from 'react-click-outside';
import { isMobile, isBrowser } from 'react-device-detect';

import NavExtraItem from 'components/molecules/NavExtraItem';
import NavSustainabilityItem from 'components/molecules/NavSustainabilityItem';

import { lanMapRoute } from 'util/i18n';
import { hotelPages } from 'util/navi';

import styles from './index.css';

class NavigationSide extends React.Component {
	constructor(props) {
		super(props);
		this.handleClickOutside = this.handleClickOutside.bind(this);
	}

	handleClickOutside(e) {
		if (this.props.onClickOutside) {
			this.props.onClickOutside(e);
		}
	}

	render() {
		const { t, lan, page, hotel, closeNavi, extraComponent, extraComponentProps } = this.props;

		return (
			<div className={styles.navigationHomeSide}>
				{/* eslint-disable indent */}
				{/* eslint-disable react/jsx-indent */}
				{extraComponent && extraComponent(extraComponentProps)}
				<div className={styles.pageWrapper}>
					{hotelPages.map(p => (
						<div key={p.id} className={styles.page}>
							<Link
								className={classnames(styles.link, {
									[styles.active]: p.route === page,
									[styles.mobileDevice]: isMobile,
									[styles.isBrowser]: isBrowser,
								})}
								to={`/${hotel}/${lanMapRoute(lan)}/${p.route}`}
								role="button"
								tabIndex="0"
								onClick={closeNavi}
								onKeyPress={() => {}}
							>
								{t(p.label)}
							</Link>
						</div>
					))}
					<NavExtraItem
						className={classnames(styles.extraItem, styles.link)}
						hotel={hotel}
						lan={lan}
					/>
					<NavSustainabilityItem className={classnames(styles.extraItem, styles.link)} lan={lan} />
				</div>
				{/* eslint-enable indent */}
				{/* eslint-enable react/jsx-indent */}
			</div>
		);
	}
}

export default translate('header')(enhanceWithClickOutside(NavigationSide));



// WEBPACK FOOTER //
// ./src/components/organisms/NavigationSide/component.js